<template>
    <div class="bookings">
        <div class="row">
            <div class="col-md-12">
                <a class="btn btn-primary" style="float:right" href="javascript:void(0)" role="button" @click="runBackgroundProcess">
                    Run Duplicate Script
                </a>
            </div>
        </div>
        <div class="title-button mt-3">
            <h1>Duplicate Customer Records</h1>
        </div>
        <div class="box">
            <div class="table__header">
                <form @submit.stop.prevent="doSearch" class="box__header form--inline">
                    <input v-model="emailSearch" type="text" placeholder="Email">
                    &nbsp;&nbsp;
                    <input v-model="pinCodeSearch" type="text" placeholder="Post Code">
                    &nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;
                    <button class="button button--small" type="submit"><span>Search</span></button>
                </form>
            </div>
            <hr />
            <vdtnet-table
                ref="table"
                :fields="fields"
                :opts="options"
                :key="tableKey"
                @edit="viewDuplicateRecordDetails"
            />
        </div>

        </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
    name: 'DuplicateCustomerIndex',
    components: {
        VdtnetTable,
    },
    computed: {
        userRole() {
            let user_role = localStorage.getItem("user_role");
            if (user_role == 1) {
                // this.showPassenger = true
            }
            return user_role
        }
    },     
    data() {
        return {
            tableKey: 0,
            pinCodeSearch:null,
            emailSearch:null,
            options: {
                ajax: {
                    url: this.$api + 'customers-merging/get-duplicate-table',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
                pageLength: 25,
            },
            fields: {
                email: {
                    label: 'Email',
                    render: (data, type, row) => {
                        if (data) {
                            return `<a href="javascript:void(0)" class="color-orange" data-action="edit">${ data }</a>`
                        } else {
                            return 'No Email Record'
                        }
                    }
                },
                count: {
                    label: 'No of Records',
                    render: (data) => {
                        return data
                    }
                }
            },
        }
    },
    methods: {
        doSearch() {
        
            const ajaxUrl = this.$api + 'customers-merging/get-duplicate-table'

            const queryString = new URLSearchParams();

            if(this.pinCodeSearch) {
                queryString.set('pincode_search', this.pinCodeSearch);
            }

            if(this.emailSearch){
                queryString.set('email_search', this.emailSearch);
            }

            const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

            // Update the datatable's AJAX URL with the Start Date & End Date query parameters
            this.options.ajax.url = urlWithParams;

            // Increment the tableKey to force re-render and fetch new data
            this.tableKey++;
        },
        viewDuplicateRecordDetails(record) {
            console.log(record);
            this.$router.push({ name: 'duplicate-customer-detail', params: { email: record.email}})
        },
        runBackgroundProcess() {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}customers-merging/merge-customers-script`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
                .then(response => {
                    this.$store.dispatch('setLoadStatus')
                    if (response.status) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                    }
            })
        }
    }   
}
</script>

<style lang="scss" scoped>

</style>